import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { ProfessionalProfilesService } from 'src/app/services/professional-profiles.service';
import { ProfessionalProfilesModalComponent } from './professional-profiles-modal/professional-profiles-modal.component';

@Component({
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  selector: 'app-professional-profiles',
  templateUrl: './professional-profiles.component.html',
  styleUrl: './professional-profiles.component.css'
})
export class ProfessionalProfilesComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private ProfessionalProfilesService: ProfessionalProfilesService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  ProfessionalProfilesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getProfessionalProfiles();
  }

  getProfessionalProfiles(){
    this.ProfessionalProfilesService.getProfessional().subscribe({
      next: (res: any) => {
        this.ProfessionalProfilesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(ProfessionalProfilesModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getProfessionalProfiles();
        }
      }
    });
  }

}
